import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { addSubscriberFields, addSubscriberTypes, getOutletType, getStatusOptionsData, getSubscriberFields, getSubscriberType, getSurveyQuestionTypes, updateSubscriberFields, updateSubscriberType } from "./SubscriberRepository";
import { toast } from "react-toastify";
import { showToast } from "../../../../utils/toastUtils";


export const useSubscriberTypesData = ({
    params = {},
    enable = false,
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
    return useQuery({
        queryKey: ["SUBSCRIBER_TYPES", params],
        queryFn: () => getSubscriberType(params),
        enabled: enable,
        retry: false,
    });
};
export const useAddSubscriberTypes = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: addSubscriberTypes,
        onSuccess: (data) => {
            showToast.success("Subscriber Type Added Successfully!");
            queryClient.invalidateQueries({ queryKey: ["SUBSCRIBER_TYPES"] });
            // <Loader />
        },
        onError: (error) => {
            showToast.warning("Failed to Add Subscriber Type!");
        },
    });
};
export const useUpdateSubscriberType = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ id, body }: { id: number; body: any }) =>
            updateSubscriberType(id, body),
        onSuccess: (data) => {
            showToast.success("Update Subscriber Type Successfully!");
            queryClient.invalidateQueries({ queryKey: ["SUBSCRIBER_TYPES"] });
        },
        onError: (error) => {
            showToast.warning("Failed to Update Subscriber Type!");
        },
    });
};
export const useOutletTypesData = ({
    params = {},
    enable = false,
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
    return useQuery({
        queryKey: ["OUTLET_TYPES"],
        queryFn: getOutletType,
        enabled: enable,
        retry: false,
    });
};

export const useSubscriberFieldsData = ({
    params = {},
    typeId = null,
    enable = false,
}: { typeId?: number|any; params?: Record<string, any>; enable?: boolean } = {}) => {
    return useQuery({
        queryKey: ["SUBSCRIBER_FIELDS", params,typeId],
        queryFn: () => getSubscriberFields(typeId, params),
        enabled: enable,
        retry: false,
    });
};


export const useAddSubscriberFields = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: addSubscriberFields,
        onSuccess: (data) => {
            showToast.success("Subscriber Fields Added Successfully!");
            queryClient.invalidateQueries({ queryKey: ["SUBSCRIBER_FIELDS"] });
            // <Loader />
        },
        onError: (error) => {
            showToast.warning("Failed to Add Fields Type!");
        },
    });
};
export const useUpdateSubscriberFields = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ id, body }: { id: number; body: any }) =>
            updateSubscriberFields(id, body),
        onSuccess: (data) => {
            showToast.success("Update Subscriber Field Successfully!");
            queryClient.invalidateQueries({ queryKey: ["SUBSCRIBER_FIELDS"] });
        },
        onError: (error) => {
            showToast.warning("Failed to Update Subscriber Field!");
        },
    });
};

export const useGetSurveyQuestionTypesData = ({
    params = {},
    enable = false,
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
    return useQuery({
        queryKey: ["SURVEY_QUES_TYPE"],
        queryFn: getSurveyQuestionTypes,
        enabled: enable,
        retry: false,
    });
};
// GET_STATUS_OPTIONS
export const useGetStatusOptionsData = ({
    params = {},
    enable = false,
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
    return useQuery({
        queryKey: ["STATUS_OPTIONS"],
        queryFn: getStatusOptionsData,
        enabled: enable,
        retry: false,
    });
};